import { FetchRequest } from '@rails/request.js'

export function turboFetchCollection(path, target, params = {}, options = {}) {
  const searchParams = new URLSearchParams(params)
  searchParams.append('target', target)

  turboRequest(`${path}?${searchParams}`, options)
}

export function turboRequest(url, options) {
  const { method = 'GET', body, onSuccess, responseKind = 'turbo-stream' } = options || {}
  document.dispatchEvent(new CustomEvent('turboRequest:start'))
  document.dispatchEvent(new CustomEvent('turboRequest:beforeSend'))

  const request = new FetchRequest(method, url, {
    responseKind,
    ...(body && { body })
  })

  request.perform()
    .then(async response => {
      if (response.ok) {
        const data = await response.html
        window.Turbo.renderStreamMessage(data)
        if (onSuccess) {
          onSuccess(data)
        }
        document.dispatchEvent(new CustomEvent('turboRequest:success'))
      } else {
        document.dispatchEvent(new CustomEvent('turboRequest:failed'))
      }
    })
    .catch(() => {
      document.dispatchEvent(new CustomEvent('turboRequest:failed'))
    })
}

export function formElementData(form, params) {
  let formData = new FormData(form)
  const formDataObj = {}

  // Converts FormData entries into a structured object and appends each key-value pair to URLSearchParams, handling multiple values per key.
  formData.forEach((value, key) => {
    if (formDataObj[key]) {
      if (!Array.isArray(formDataObj[key])) {
        formDataObj[key] = [formDataObj[key]]
      }
      formDataObj[key].push(value)
    } else {
      formDataObj[key] = value
    }
  })

  Object.keys(formDataObj).forEach(key => {
    if (Array.isArray(formDataObj[key])) {
      formDataObj[key].forEach(value => {
        params.append(key, value)
      })
    } else {
      params.append(key, formDataObj[key])
    }
  })
  return params
}
